import { EBannerType, TGuideList } from 'shared/types/guide';
import { EOfferType } from 'shared/types/wantType';
import { PLACE_AD } from './links';

export const HOSTS_GUIDE_LIST: TGuideList[] = [
  {
    step: 1,
    title: 'Выбор и подготовка недвижимости',
    slider: [
      {
        image: 'hosts/daily-rent-b0cebea2e662ce8f9b9a2a1e59e3fefb.png',
        title: 'Рынок посуточной аренды: тенденции и перспективы',
        notice: '3 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-rynok-posutochnoj-arendy-trendy-i-perspektivy-341020/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/what-important-1b341559eff047ad6aef8412e6472efc.png',
        title: 'Что важно при покупке квартиры для краткосрочной аренды',
        notice: '6 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://spb.cian.ru/stati-chto-vazhno-pri-pokupke-kvartiry-dlja-kratkosrochnoj-arendy-341408/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/criteria-choosing-a7c1d63b10a0c598156b34b242e32d9c.png',
        title: 'Критерии выбора дома и рентабельности недвиги для посуточной аренды',
        notice: '5 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://spb.cian.ru/stati-kak-rabotat-s-zagorodnymi-domami-posutochno-opyt-agentstva-s-400-obektami-341691/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/how-calculate-12bc161f9b49bf59a00de87f1216bce4.png',
        title: 'Как рассчитать рентабельность квартиры для посуточной аренды: опыт управляющей компании',
        notice: '5 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://spb.cian.ru/stati-rentabelnost-kvartiry-dlja-posutochnoj-arendy-340820/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/how-prepare-bdea09a8702791da427b8704164becc0.png',
        title: 'Как подготовить посуточную квартиру и дом для сдачи в аренду ',
        notice: '10 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-houmstejdzhing-dlja-posutochnoj-arendy-341818/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/popular-interior-e1ed50f8bc76d19824146570b730c614.png',
        title: 'Популярные интерьерные тренды, которые помогут сдать недвижимость',
        notice: '6 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-populjarnye-interernye-trendy-kotorye-pomogut-sdat-nedvizhimost-334949/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/what-is-home-e2b97c88926c123850245975f26eaed5.png',
        title: 'Что такое хоумстейджинг и как это работает',
        notice: '15 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-chto-takoe-houmstejdzhing-i-kak-eto-rabotaet-325088/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'hosts/how-to-organize-76b23e1a7b4c1b79dddb6465b541b10c.png',
        title: 'Как организовать бесконтактное заселение при сдаче в аренду',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-kak-organizovat-beskontaktnoe-zaselenie-pri-sdache-kvartiry-v-arendu-330997/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'hosts/household-dd73032f16e6523b3027a8020ac6667d.png',
        title: 'Бытовая техника: минимальный набор для квартиры под сдачу',
        notice: '3 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-bytovaja-tehnika-minimalnyj-nabor-dlja-kvartiry-pod-sdachu-328895/?cian_source=guide&cian_medium=host',
      },
    ],
  },
  {
    step: 2,
    title: 'Юридические аспекты',
    slider: [
      {
        image: 'hosts/legal-subtleties-e73f86a08241e005a07a3da30df44672.png',
        title: 'Юридические тонкости посуточной аренды: объясняет юрист',
        notice: '3 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-juridicheskie-tonkosti-posutochnoj-arendy-objasnjaet-jurist-341001/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/how-can-a-host-298031cc64f26d77b09e554f5096629d.png',
        title: 'Как хосту работать официально и не попасть под штрафы ФНС',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-kak-hostu-rabotat-ofitsialno-i-ne-popast-pod-shtrafy-nalogovoj-341153/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/how-will-2261885aa35de13daabdcce892fdbd9a.png',
        title: 'Как налоговая узнает о сдаче квартиры в аренду и что за это будет',
        notice: '9 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://spb.cian.ru/stati-kak-nalogovaja-uznaet-o-sdache-kvartiry-v-arendu-i-chto-za-eto-budet-330021/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/how-to-prepare-doc-f697fa6c69179614ec0312ee68f164ac.png',
        title: 'Как оформить документы для командировочных: советы юриста',
        notice: '2 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-oformit-dokumenty-dlja-komandirovochnyh-sovety-jurista-339809/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/self-employed-208bf4ae3cf8c978ca0e76d73780c1da.png',
        title: 'Самозанятые: как сдавать квартиру в аренду и уплачивать налог',
        notice: '8 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-arendodatel-zaplati-nalog-i-spi-spokojno-samozanjatye-arendodateli-shag-1-293361/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/working-legaly-cceb7470e72f7adbc3b53f2e2563a8b1.png',
        title: 'Работа по закону: как легализация меняет бизнес в посуточной аренде',
        notice: '2 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-rabota-po-zakonu-kak-legalizatsija-menjaet-biznes-v-posutochnoj-arende-341243/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/sublease-d2cf9a0d1248c63020e106ad7102c953.png',
        title: 'Субаренда: чем отличается от аренды и как составить договор',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-subarenda-chem-otlichaetsja-ot-arendy-i-kak-sostavit-dogovor-337722/?cian_source=guide&cian_medium=host',
      },
    ],
    banner: {
      mainBanner: {
        type: EBannerType.Blue,
        title: 'Размещайтесь на Циан.Посуточно',
        linkBtn: { url: PLACE_AD, text: 'Разместить объявление' },
        imageClass: 'cian-calendar',
      },
    },
  },
  {
    step: 3,
    title: 'Создание объявления',
    slider: [
      {
        image: 'hosts/how-to-take-b23a56cb89114d55ed7383aa0d3577bc.png',
        title: 'Как снимать фото и видео для объявления об аренде?',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-kak-snimat-foto-i-video-dlja-objavlenija-ob-arende-328854/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/selling-ad-45f23ee7e6c832593e6b8a9c10febb7e.png',
        title: 'Продающий текст объявления: как выделиться в посуточной аренде',
        notice: '3 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-prodajuschij-tekst-objavlenija-kak-vydelitsja-v-posutochnoj-arende-340035/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/cian-daily-upd-49ede80d4d8f5660f7a189e659261f01.png',
        title: 'Циан.Посуточно обновил сервис для гостей на колясках: что важно знать хостам',
        notice: '5 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://spb.cian.ru/stati-tsianposutochno-obnovil-servis-dlja-gostej-na-koljaskah-chto-vazhno-znat-hostam-341319/?cian_source=guide&cian_medium=host',
      },
    ],
  },
  {
    step: 4,
    title: 'Продвижение и маркетинг',
    slider: [
      {
        image: 'hosts/superagent-status-1ba664db1493c1674beb420db80aa4e0.png',
        title: 'Статус Суперхозяин: всё о программе лояльности',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-status-superhozjain-vse-o-programme-lojalnosti-341490/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/how-cian-verified-2032b4427ef1b6a9ee5c3179176e9874.png',
        title: 'Как значок «Проверено Циан» увеличивает спрос на объекты посуточной аренды',
        notice: '3 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-znachok-provereno-tsian-uvelichivaet-spros-na-obekty-posutochnoj-arendy-337717/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/what-influences-dcc3bc19c83ee5f36f4c6619127b21c2.png',
        title: 'Что влияет на выбор гостя: советы опытного хоста',
        notice: '3 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-chto-vlijaet-na-vybor-gostja-sovety-opytnogo-hosta-340917/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/using-social-media-dd83df205d5f3cce507e90196ad9ac7d.png',
        title: 'Использование социальных сетей и других каналов для продвижения',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-kak-vydelitsja-v-posutochnoj-arende-sekrety-alternativnogo-marketinga-341062/?cian_source=guide&cian_medium=host',
      },
    ],
    banner: {
      mainBanner: {
        type: EBannerType.Colored,
        title: 'Как эффективно работать с онлайн-бронированием на Циан и принимать больше гостей',
        linkBtn: {
          text: 'Узнать больше',
          url: '',
        },
        imageClass: 'apart',
      },
    },
  },
  {
    step: 5,
    title: 'Взаимодействие с гостями',
    slider: [
      {
        image: 'hosts/communicating-with-2072049c4f8636ea24fcb11f03fb92d1.png',
        title: 'Общение с гостями в посуточной аренде: как сделать, чтобы клиенты вернулись',
        notice: '6 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-obschenie-s-gostjami-v-posutochnoj-arende-kak-sdelat-chtoby-klienty-vernulis-335987/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/daily-rental-business-7546b8539c70beee77cb22a84a987373.png',
        title: 'Посуточный бизнес: как вырасти до 150 квартир и сохранить сервис',
        notice: '5 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-posutochnyj-biznes-kak-vyrasti-do-150-kvartir-i-sohranit-servis-339888/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/providing-high-quality-2c2505290581a38d2b030e3a20164fc2.png',
        title: 'Обеспечение качественного сервиса в посуточных домах',
        notice: '5 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://spb.cian.ru/stati-osnovy-horoshego-servisa-v-zagorodnom-dome-341922/?cian_source=guide&cian_medium=host',
      },
      {
        image: 'hosts/case-study-9c8b0289ca8e6eb4eff56d7a1a4d07d9.png',
        title: 'Кейс с компанией Квартал: как мотивировать гостей оставлять отзывы',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-kejs-kompanii-kvartal-kak-motivirovat-gostej-ostavljat-otzyvy-338500/?cian_source=guide&cian_medium=host',
      },
    ],
  },
];
